export function focusSearch() {
	document.querySelector('[name="q"]').focus();
}


const respNavbar = document.querySelector('#responsive-navbar');
const body = document.querySelector('body');
const observer = new MutationObserver(function (events) {
		let isClosed = events[0].target.classList.contains('translate-x-full');
		if (isClosed) {
			body.classList.remove('overflow-y-hidden');
		} else {
			body.classList.add('overflow-y-hidden');
		}
	setTimeout(function () {}, 100)
})

observer.observe(respNavbar, {
	attributes: true,
	attributeFilter: ['class'],
	childList: false,
	characterData: false
});